// extracted by mini-css-extract-plugin
module.exports = {"layout":"A4_65_Labels_EU30019_layout__mqPva"};